// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"6f3a2e33","121":"448f1a06","364":"27149167","854":"22da4654","950":"8c5b0ed2"}[chunkId] + ".chunk.js";
};